import {
  HeroBanner,
  HeroBannerRightPanel,
  SanityImageRatio,
  SanityImage,
  HeroBannerLeftPanel,
  HeroBannerCenterPanel
} from "@silversea-ssc/ui-components-react";
import PageBuilderDividerWithCTA from "components/PageBuilder/PageBuilderDividerWithCTA";
import React from "react";
import { PageBuilderOpeningHeroFragment } from "types/graphql-types";
import * as styles from "./CalligraphicOpeningHero.module.scss";

type Props = PageBuilderOpeningHeroFragment;

const WrapperComponentMap = {
  right: HeroBannerRightPanel,
  left: HeroBannerLeftPanel,
  center: HeroBannerCenterPanel
};

const CalligraphicOpeningHero: React.FC<Props> = ({
  background,
  calligraphicTitle,
  calligraphicTitlePosition = "right",
  ctaButtons = []
}) => {
  const WrapperComponent =
    WrapperComponentMap[calligraphicTitlePosition] || HeroBannerRightPanel;

  return (
    <React.Fragment>
      <HeroBanner background={background} overlayClassName={styles.heroOverlay}>
        <WrapperComponent>
          <SanityImageRatio image={calligraphicTitle} ratio="auto">
            <SanityImage image={calligraphicTitle} fit="original" />
          </SanityImageRatio>
        </WrapperComponent>
      </HeroBanner>
      {ctaButtons.length > 0 && (
        <PageBuilderDividerWithCTA
          backgroundColorBottom="white"
          ctaButtons={ctaButtons}
          className={styles.overlayFooter}
        />
      )}
    </React.Fragment>
  );
};

export default CalligraphicOpeningHero;
